export default "__VITE_ASSET__BEWpbIMn__"